import React from 'react';
import ReactDOM from 'react-dom';
import AuthForm from './AuthForm';
import { SignInModalTab } from '../SignInModal/types';
import { AccountModalConfigProvider } from '../SignInModal/AccountModalConfigContext';

const renderAuthForm = (
  returnUrl?: string,
  defaultTabOverride?: SignInModalTab,
  trackingOptions?: { location: string },
  prePopulatedEmail?: string
) => {
  const mountNode = document.querySelector('[react-render-target="auth-form-container"]');
  if (mountNode)
    ReactDOM.render(
      <AccountModalConfigProvider>
        <AuthForm
          returnUrl={returnUrl}
          defaultTabOverride={defaultTabOverride}
          trackingOptions={trackingOptions}
          prePopulatedEmail={prePopulatedEmail}
        />
      </AccountModalConfigProvider>,
      mountNode
    );
  else console.warn('missing render target: AuthForm');
};

export const initAuthForm = (
  returnUrl?: string,
  defaultTabOverride?: SignInModalTab,
  trackingOptions?: { location: string },
  prePopulatedEmail?: string
) => {
  renderAuthForm(returnUrl, defaultTabOverride, trackingOptions, prePopulatedEmail);
};
